import axios from 'axios';
import axiosInstance from './AxiosInstance';
import { STORAGE_API_URL } from '../constant';

/**
 * Mendapatkan detail kuota storage SchoolMedia berdasarkan UUID pengguna (Tenant ID)
 * Endpoint utama: GET https://storage.schoolmedia.id/api/v1/quota/detail
 * Headers:
 *  - Content-Type: application/json
 *  - X-Tenant-ID: <uuid>
 *
 * @param {string|null} tenantId - UUID pengguna yang sedang login (dari endpoint me)
 * @returns {Promise<object>} response data kuota storage
 */
export const getStorageQuotaDetail = async (tenantId = null) => {
  let finalTenantId = tenantId;
  if (!finalTenantId && typeof window !== 'undefined') {
    try {
      finalTenantId =
        localStorage.getItem('uuid') ||
        localStorage.getItem('user_uuid') ||
        (() => {
          const raw = localStorage.getItem('userDetails');
          if (!raw) return null;
          const parsed = JSON.parse(raw);
          return parsed?.uuid || parsed?.detail?.uuid || parsed?.data?.uuid || null;
        })();
    } catch (e) {
      console.error('Error resolving tenantId from storage:', e);
    }
  }

  if (!finalTenantId) {
    return Promise.reject(new Error('Tenant ID (UUID) is required'));
  }

  const baseUrl = STORAGE_API_URL || 'https://storage.schoolmedia.id/api/v1';

  try {
    // 1. Prioritaskan direct request ke https://storage.schoolmedia.id/api/v1/quota/detail
    const response = await axios.get(`${baseUrl}/quota/detail`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Tenant-ID': finalTenantId,
      },
      timeout: 3500,
    });
    return response.data;
  } catch (directErr) {
    // 2. Jika direct request diblokir oleh CORS browser (misal domain .site pada development),
    // fallback menggunakan axiosInstance ke /storage/quota yang sudah ber-CORS
    console.warn('[StorageService] Direct call to storage.schoolmedia.id blocked by CORS/network, using backend proxy fallback:', directErr?.message);
    const fallbackRes = await axiosInstance.get('storage/quota', {
      headers: {
        'Content-Type': 'application/json',
        'X-Tenant-ID': finalTenantId,
      },
    });
    return fallbackRes.data;
  }
};

// Alias untuk kompatibilitas pemanggilan
export const getStorageQuota = getStorageQuotaDetail;

const StorageService = {
  getStorageQuotaDetail,
  getStorageQuota,
};

export default StorageService;
